import { Controller } from '@hotwired/stimulus'
import {  enter, leave  } from "./../helpers/transition"

export default class extends Controller {
  static targets = ['progress']
  static values = {
    dismissAfter: Number,
    showDelay: { type: Number, default: 0 },
  }

  connect() {
    setTimeout(() => {
      enter(this.element)
    }, this.showDelayValue)

    // Auto dimiss if defined
    if (this.hasDismissAfterValue) {
      this.progressTarget.style.animationDuration = this.dismissAfterValue + 'ms'
      setTimeout(() => {
        this.close()
      }, this.dismissAfterValue)
    }
  }

  // Runs hide animation and then removes element from the page
  close() {
    const element = this.element
    element.classList.add('animate__animated','animate__bounceOutRight')
    element.addEventListener('animationend', () => {
      setTimeout(() => {
        this.element.remove()
      }, 500)
    });
  }
}
